import { ChevronDown, ChevronUp, Download, FileText } from 'lucide-react'

import { Button, DropdownMenu } from 'slab'

interface StripeInvoiceDropdownProps {
  invoicePdf: string | null
}

export function StripeInvoiceDropdown ({ invoicePdf }: StripeInvoiceDropdownProps) {
  const handleDownloadPDFClick = () => {
    if (invoicePdf) {
      window.open(invoicePdf, '_blank')
    }
    return false
  }

  return (
    <DropdownMenu
      trigger={({ open }) => (
        <Button
          variant='tertiary'
          disabled={!invoicePdf}
          rightIcon={open ? ChevronUp : ChevronDown}
          leftIcon={Download}
        >
          Download
        </Button>
      )}
      align='end'
    >
      <DropdownMenu.Item
        leftIcon={FileText}
        onSelect={handleDownloadPDFClick}
      >
        Invoice PDF
      </DropdownMenu.Item>
    </DropdownMenu>
  )
}
